<script>
  import WarningIcon from "./icons/WarningIcon.svelte";
</script>

<style>
  .warning {
    align-items: center;
    background-image: linear-gradient(to bottom, #fbfb98, #f1f14f);
    box-shadow: var(--button-box-shadow);
    border-radius: 5px;
    display: flex;
    padding: 2rem 1rem;
    margin-bottom: 3rem;
  }

  .text {
    flex: 1;
    margin-left: 1rem;
  }
</style>

<div class="warning">
  <WarningIcon />
  <div class="text">
    Some results could not be displayed because you requested too many levels.
    Try again with a smaller number of levels.
  </div>
</div>
